export default __webpack_public_path__ + "e87018014f6ac676a2c9fbfc56ac6772.png";